<div class="upload-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>cloud_upload</mat-icon>
      Upload File
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <!-- Hidden file input -->
    <input #fileInput type="file" accept=".pdf" (change)="onFileInputChange($event)" style="display: none" />

    <!-- Drag & Drop Area -->
    <div
      class="drop-zone"
      [class.drag-over]="isDragOver"
      [class.has-file]="selectedFile"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      (click)="triggerFileInput()"
      (keydown.enter)="triggerFileInput()"
      (keydown.space)="triggerFileInput(); $event.preventDefault()"
      tabindex="0"
      role="button"
      aria-label="Click or drop PDF file here"
    >
      <!-- No file selected state -->
      @if (!selectedFile) {
        <div class="drop-zone-content">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <h3>Drag & drop your PDF file here</h3>
          <p>
            or
            <strong>click to browse</strong>
          </p>
          <div class="file-requirements">
            <small>
              <mat-icon class="requirement-icon">info</mat-icon>
              PDF files only, max {{ maxFileSizeMb }}MB
            </small>
          </div>
        </div>
      }

      <!-- File selected state -->
      @if (selectedFile) {
        <div class="selected-file-preview">
          <mat-icon class="file-icon">description</mat-icon>
          <div class="file-details">
            <div class="file-name">{{ selectedFile.name }}</div>
            <div class="file-size">{{ formatFileSize(selectedFile.size) }}</div>
          </div>
          <button
            mat-icon-button
            class="remove-file-button"
            (click)="clearSelectedFile(); $event.stopPropagation()"
            matTooltip="Remove file"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
    </div>

    <!-- Upload progress -->
    @if (uploading) {
      <mat-progress-bar mode="indeterminate" class="upload-progress"></mat-progress-bar>
    }
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" [disabled]="uploading">Cancel</button>
    <button mat-raised-button color="primary" (click)="onUpload()" [disabled]="!isUploadValid()">
      <mat-icon>upload</mat-icon>
      Upload File
    </button>
  </div>
</div>
